module.exports = __webpack_public_path__ + "img/fundermax-obra-2-2.7ce1ce03.jpg";